module.exports = __webpack_public_path__ + "img/calendar-17_fill.e8671efc.svg";